// =============================================================================
// FILE:
// frontend/src/modules/pms/material_logistics/services/materialReceiptService.js
// =============================================================================

import axiosClient from "../../../../api/axiosClient";


// =============================================================================
// CREATE RECEIPT FROM DISPATCH
// =============================================================================
export const createReceiptFromDispatch = async (payload) => {

    const response = await axiosClient.post(

        "/api/pms/material-receipt/create-from-dispatch",

        payload
    );

    return response.data;
};


// =============================================================================
// GET RECEIPT DETAIL
// =============================================================================
export const getReceiptDetail = async (receiptHeaderId) => {

    const response = await axiosClient.get(

        `/api/pms/material-receipt/${receiptHeaderId}`
    );

    return response.data;
};


// =============================================================================
// GET RECEIPT LIST
// =============================================================================
export const getReceiptList = async () => {

    const response = await axiosClient.get(

        "/api/pms/material-receipt/list"
    );

    return response.data;
};


// =============================================================================
// RECEIVE SHIPMENT
// =============================================================================
export const receiveShipment = async (

    receiptHeaderId,

    payload = {}
) => {

    const response = await axiosClient.post(

        `/api/pms/material-receipt/${receiptHeaderId}/receive`,

        payload
    );

    return response.data;
};


// =============================================================================
// SAVE RECEIPT VERIFICATION
// =============================================================================
export const saveReceiptVerification = async (

    receiptHeaderId,

    payload
) => {

    const response = await axiosClient.post(

        `/api/pms/material-receipt/${receiptHeaderId}/save-verification`,

        payload
    );

    return response.data;
};
// =============================================================================
// SUBMIT RECEIPT
// =============================================================================
export const submitReceipt = async (receiptHeaderId) => {

    const response = await axiosClient.post(

        `/api/pms/material-receipt/${receiptHeaderId}/submit`
    );

    return response.data;
};

// =============================================================================
// SAVE RECONCILIATION
// =============================================================================
export const saveReconciliation = async (

    receiptHeaderId,

    payload
) => {

    const response = await axiosClient.post(

        `/api/pms/material-receipt/${receiptHeaderId}/save-reconciliation`,

        payload
    );

    return response.data;
};


// =============================================================================
// APPROVE RECONCILIATION
// =============================================================================
export const reconcileReceipt = async (receiptHeaderId) => {

    const response = await axiosClient.post(

        `/api/pms/material-receipt/${receiptHeaderId}/reconcile`
    );

    return response.data;
};

// =============================================================================
// GET ELIGIBLE DISPATCHES FOR RECEIPT
// =============================================================================
export const getEligibleDispatchesForReceipt =
  async (params = {}) => {

    const response =
      await axiosClient.get(

        "/api/pms/material-dispatch/eligible-for-receipt",

        {
          params
        }
      );

    return response.data;
  };
// =============================================================================
// SAVE BOX VERIFICATION
// =============================================================================
export const saveBoxVerification =
  async (

    receiptId,

    payload
  ) => {

    const response =
      await axiosClient.post(

        `/api/pms/material-receipt/${receiptId}/save-box-verification`,

        payload
      );

    return response.data;
  };


// =============================================================================
// CONFIRM BOX VERIFICATION
// =============================================================================
export const confirmBoxVerification =
  async (receiptId) => {

    const response =
      await axiosClient.post(

        `/api/pms/material-receipt/${receiptId}/confirm-box-verification`
      );

    return response.data;
  };
  